import { CallAttributes, WebphonePhoneStateEvent } from '../types';
import { PcsConversationType } from '../lib/getPcsConversation';
import { phoneState, phoneStateCallExists } from '../state';
import IAppLogger from '@app/lib/IAppLogger';
import getRecordingState from '../lib/getRecordingState';

const handlePcsConversationFetched = (
  pcsConversation: PcsConversationType,
  phoneStateUpdateEvent: WebphonePhoneStateEvent,
  logger: IAppLogger,
) => {
  const { callId } = phoneStateUpdateEvent.callState;

  if (!pcsConversation) {
    logger.error(
      `PcsConversation not found for remoteCallId ${phoneStateUpdateEvent.callState.remoteCallId}}`,
    );
    return;
  }

  const initialRecordingState = getRecordingState();

  const attributes: CallAttributes = {
    pcsConversationSid: pcsConversation.sid,
    queueIds: pcsConversation.queueIds,
    tenantId: pcsConversation.tenantId,
    traits: pcsConversation.traits,
    recordingState: initialRecordingState,
  };

  // ensure call still exists in callList when pcsConversation resolves
  if (phoneStateCallExists(callId)) {
    phoneState.callAttributes[callId] = attributes;
  }
};

export default handlePcsConversationFetched;
